import { tokensMappingBase } from '@/utils/tokens';
import {
  ArrowRightIcon,
  Box,
  CurrencyValue,
  DataTable,
  EtherScanPictogram,
  Flex,
  Heading,
  RelativeDateTime,
  WalletAddress
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

export default function TokenEventsTable({ pagination, data, sorting }) {
  const columns: TableColumn[] = [
    {
      header: 'Wallet Address',
      getCell: (row) => (
        <WalletAddress
          address={row.sender}
          options={{ sizes: { blockie: '0' } }}
        />
      )
    },
    {
      header: 'Event',
      getCell: (row) => row.event
    },
    {
      header: (
        <Flex display="flex" flexDirection="row" alignItems="center" gap="3xs">
          Amount In
        </Flex>
      ),
      getCell: (row) => (
        <CurrencyValue
          value={row.amount_in}
          options={{
            currency: tokensMappingBase(row.asset_symbol_in),
            iconSize: '1'
          }}
        />
      ),
      cellAlign: 'flex-end',
      headerAlign: 'flex-end',
      sortingField: 'amount_in'
    },
    {
      header: '',
      getCell: () => (
        <Box color="muted">
          <ArrowRightIcon size="1" />
        </Box>
      ),
      cellAlign: 'center',
      headerAlign: 'center',
      columnSize: ['1.5rem']
    },
    {
      header: (
        <Flex display="flex" flexDirection="row" alignItems="center" gap="3xs">
          Amount Out
        </Flex>
      ),
      getCell: (row) => (
        <CurrencyValue
          value={row.amount_out}
          options={{
            currency: tokensMappingBase(row.asset_symbol_out),
            iconSize: '1'
          }}
        />
      ),
      cellAlign: 'flex-start',
      headerAlign: 'flex-start',
      sortingField: 'amount_out'
    },
    {
      header: 'Time',
      getCell: (row) => (
        <Flex gap={['xs', '2xs']} color="muted">
          <RelativeDateTime value={row.datetime} />
          <a
            href={`https://basescan.org/tx/${row.tx_hash}`}
            target="_blank"
            rel="noreferrer">
            <EtherScanPictogram size="0" />
          </a>
        </Flex>
      ),
      cellAlign: 'flex-end',
      headerAlign: 'flex-end',
      sortingField: 'order_index'
    }
  ];

  return (
    <>
      <Flex justifyContent="space-between">
        <Heading size="2">Events</Heading>
      </Flex>
      <DataTable
        rows={data['results']}
        columns={columns}
        getKey={(row) => row.order_index + row.wallet_address}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    </>
  );
}
